import BaseAPI from '../base/baseApi';
import httpClient from '@/apis/base/httpclient';
class DashboardDataApi extends BaseAPI {
  constructor() {
    super();
  }

  controllerName = 'DashboardDatas';
  apiName = 'BU';

  /**
   * Lấy dữ liệu biểu đồ
   * @param {*} payload
   * @returns
   * pntoan 20.4.2024
   */
  getDashboardBudgetPlanAVA(payload) {
    const request = {
      url: this.getAPIUrl() + '/getDashboardBudgetPlanAVA',
      data: payload,
    };

    return this.postAsync(request);
  }
  /**
   * Lấy dữ liệu biểu đồ
   * @param {*} payload
   * @returns
   * pntoan 20.4.2024
   */
  getDashboardReceiptExpenseAVA(payload) {
    const request = {
      url: this.getAPIUrl() + '/getDashboardReceiptExpenseAVA',
      data: payload,
    };

    return this.postAsync(request);
  }

  /**
   * Lấy dữ liệu từ cache trường hợp chết WS
   * @param {*} payload
   * @returns
   * NXHung 24.05.2024
   */
  getCacheDashboardAsync(paramKey) {
    const request = {
      url: this.getAPIUrl() + '/cacheDashboardAsync/' + paramKey,
    };

    return this.getAsync(request);
  }
}

export default new DashboardDataApi();
